export enum ItemWithSinistersUrls {
   DETAIL_INFO = '/ranch/claims/',
   SINISTER_NOTES = '/ranch/notes/',
   SATELLITAL_IMAGES = '/ranch/satellital/images/',
   SATELLITAL_VALUES = '/ranch/satellital/values/',
   STATS_SATELLITAL_VALUES = '/ranch/satellital/values/stats/',
   MAP_LAYERS = '/ranch/satellital/map_layers/',

   ZONIFICATION = '/ranch/satellital/ndvi_zonify/',
   NDVI_DIFF = '/ranch/satellital/ndvi_diff/',
   SAMPLING_CLASSIFICATION = '/ranch/sampling/classification/'
}